export const AUTH_CONFIG = {
  SOCKET_TIMEOUT: 60 * 1000, // 60 seconds
  QR_SIZE: 220,
  MAX_WIDTH: 490,
} as const;

export const STORAGE_KEYS = {
  WEB_KEY: "webKey",
  FINGERPRINT: "fingerprint",
} as const;
